import {createContext} from "react";

export interface ProjectCardExpansion {
    expanded: boolean;
    setExpanded(expanded: boolean): void;
    titleTruncated: boolean;
    setTitleTruncated(truncated: boolean): void;
}

const noop = () => undefined;

export const ProjectCardExpansionContext = createContext<ProjectCardExpansion>({
    expanded: false,
    setExpanded: noop,
    titleTruncated: false,
    setTitleTruncated: noop,
});
